import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Header } from '../../header';
import { useNotify } from "tailwind-notifications-react";

export const TagsPage = () => {
  const [tags, setTags] = useState([]);
  const [tagName, setTagName] = useState('');
  const [tagColor, setTagColor] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editTagId, setEditTagId] = useState(null);
  const token = localStorage.getItem('token');

  const notify = useNotify();

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const response = await axios.get('https://api.alyonatestsite.store/api/tags', {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setTags(response.data);
    } catch (error) {
      console.error('Ошибка загрузки тэгов:', error);
    }
  };

  const handleDeleteTag = async (id) => {
    try {
      await axios.delete(`https://api.alyonatestsite.store/api/tags/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      fetchTags();
      notify({
        title: "Успешно",
        message: `Тэг был успешно удалён.`,
        type: "success",
      });
    } catch (error) {
      console.error('Ошибка удаления тэга:', error);
    }
  };

  const handleAddTag = async () => {
    try {
      const response = await axios.post(
        'https://api.alyonatestsite.store/api/tags/',
        {
          name: tagName,
          color: tagColor,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchTags();
      setTagName('');
      setTagColor('');
      notify({
        title: "Успешно",
        message: `Тэг был успешно добавлен.`,
        type: "success",
      });
    } catch (error) {
      console.error('Ошибка добавления тэга:', error);
    }
  };

  const handleEditTag = (id) => {
    const tag = tags.find((tag) => tag.id === id);
    if (tag) {
      setTagName(tag.name);
      setTagColor(tag.color);
      setEditTagId(id);
      setIsEditing(true);
    }
  };

  const handleUpdateTag = async () => {
    try {
      await axios.put(`https://api.alyonatestsite.store/api/tags/${editTagId}`, {
        name: tagName,
        color: tagColor,
      });
      fetchTags();
      setIsEditing(false);
      setTagName('');
      setTagColor('');
      setEditTagId(null);
      notify({
        title: "Успешно",
        message: `Товар был успешно обновлён.`,
        type: "success",
      });
    } catch (error) {
      console.error('Ошибка обновления тэга:', error);
    }
  };

  return (
    <section className="bg-white min-h-screen">
      <Header fixed={false} />

      <div className="p-8">
        <h1 className="text-3xl font-bold mb-6">Добавление тэга</h1>
        <div className="flex flex-col gap-4">
          <input
            type="text"
            className="p-2 border rounded"
            placeholder="Имя тэга"
            value={tagName}
            onChange={(e) => setTagName(e.target.value)}
          />
          <input
            type="text"
            className="p-2 border rounded"
            placeholder="Цвет тэга (должен быть в формате HEX, без символа #)"
            value={tagColor}
            onChange={(e) => setTagColor(e.target.value)}
          />
          <button
            onClick={handleAddTag}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Добавить тэг
          </button>
        </div>

        <div className="py-12">
          <div className="bg-gray-300 w-full h-[2px]" />
        </div>

        <h1 className="text-3xl font-bold mb-6">Управление тэгами</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {tags.map((tag) => (
            <div
              key={tag._id}
              className="border rounded p-4 shadow-md flex flex-col justify-center w-full items-center"
            >
              <span
                style={{ backgroundColor: `#${tag.color}` }}
                className={`font-crooker text-white font-bold text-sm px-4 py-1 rounded-2xl`}
              >
                {tag.name}
              </span>
              <button
                onClick={() => handleDeleteTag(tag._id)}
                className="bg-red-500 text-white px-4 py-2 rounded mt-4 w-full"
              >
                Удалить
              </button>
              <button
                onClick={() => handleEditTag(tag._id)}
                className="bg-sky-500 text-white px-4 py-2 rounded mt-4 w-full"
              >
                Редактировать
              </button>
            </div>
          ))}
        </div>

        {isEditing && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-8 rounded shadow-lg w-96">
              <h2 className="text-2xl font-bold mb-4">Редактирование тэга</h2>
              <input
                type="text"
                className="p-2 border rounded w-full mb-4"
                placeholder="Имя тэга"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
              />
              <input
                type="text"
                className="p-2 border rounded w-full mb-4"
                placeholder="Цвет тэга (HEX, без символа #)"
                value={tagColor}
                onChange={(e) => setTagColor(e.target.value)}
              />
              <div className="flex gap-4">
                <button
                  onClick={handleUpdateTag}
                  className="bg-blue-500 text-white px-4 py-2 rounded w-full"
                >
                  Сохранить
                </button>
                <button
                  onClick={() => setIsEditing(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded w-full"
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
